import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { crossScreenFontSize, link, toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import { FONT_SIZE_TEXT, ITEM_TYPES } from '../../../constants/index';
import { COL_SIZES } from './Col';
import Media from '../../Media';
import LinkFade from '../../LinkFade';
import mq from '@/utils/media-queries';

const previewLinkStyles = css`
  display: block;
  color: ${props => props.theme.colorText};
  text-decoration: none;
`;

const StyledLinkFade = styled(LinkFade)`
  ${previewLinkStyles};
`;

const StyledExternalLink = styled.a`
  ${previewLinkStyles};
`;

const PreviewLink = ({ externalUrl, type, slug, ...rest }) =>
  externalUrl ? (
    <StyledExternalLink href={externalUrl} target="_blank" {...rest} />
  ) : (
    <StyledLinkFade to={type === ITEM_TYPES.news ? `/ru/news/${slug}` : `/ru/cases/${slug}`} {...rest} />
  );

PreviewLink.propTypes = {
  externalUrl: PropTypes.string,
  type: PropTypes.oneOf([ITEM_TYPES.case, ITEM_TYPES.news]).isRequired,
  slug: PropTypes.string,
};

const StyledMedia = styled(Media)`
  margin-bottom: ${toVw(33)};
  width: 100%;

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(32)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(25)};
  `)};
`;

const Text = styled.div`
  ${crossScreenFontSize(FONT_SIZE_TEXT)};
  max-width: ${toVw(504)};

  a {
    ${link};
    text-decoration: none;
  }

  ${mq.tablet(css`
    max-width: ${toVwTablet(560)};
  `)};

  ${mq.mobile(css`
    max-width: ${toVwMobile(416)};
  `)};
`;

const Type = styled.span`
  font-weight: 700;
`;

const Preview = ({ media, excerpt, type, page, slug, size, externalUrl }) => (
  <PreviewLink externalUrl={externalUrl} type={type} data-test="item-link" data-link slug={slug}>
    <StyledMedia {...media} sizes={[`${toVw(COL_SIZES[size])}`]} />
    <Text>
      <span dangerouslySetInnerHTML={{ __html: excerpt }} />
    </Text>
  </PreviewLink>
);

Preview.propTypes = {
  media: PropTypes.object.isRequired,
  excerpt: PropTypes.string.isRequired,
  type: PropTypes.oneOf([ITEM_TYPES.case, ITEM_TYPES.news]).isRequired,
  page: PropTypes.oneOf([ITEM_TYPES.case, ITEM_TYPES.news]),
  slug: PropTypes.string,
  size: PropTypes.any.isRequired,
  noLazy: PropTypes.bool,
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/ContentRows/components/Preview.js